import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["cheggTldFrom"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import Cookie from 'js-cookie';
import clientComputeTldFrom from './clientComputeTldFrom';
import getCookieDomain from './getCookieDomain';
/**
 * Client-side function that sets the given cookie key and value.  Optional arguments can also be
 * passed to configure cookie attributes, including domain, path, and duration.
 * @param {CookieName} name    cookie name
 * @param {string}     value   cookie value
 * @param {Object}     options cookie options
 * @returns {void}
 */
export var clientSetCookie = function clientSetCookie(name, value) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var cheggTldFrom = options.cheggTldFrom,
    cookieAttributes = _objectWithoutProperties(options, _excluded);
  var targetTldFrom = clientComputeTldFrom(cheggTldFrom);
  Cookie.set(name, value, _objectSpread({
    domain: getCookieDomain(name, targetTldFrom)
  }, cookieAttributes));
};
export default clientSetCookie;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/utils/dist/esm/cookies/clientSetCookie.js
// module id = 803
// module chunks = 11